import React from 'react';
import { useTranslations } from '@/shared/ui/selects/select-options/hooks';
import { BodyTextMediumA, BodyTextRegularB } from '@/shared/ui/typography2';
import { BonusConditionsCard, StepsList, WhiteText } from './styles';
import { interpolateTemplate } from '../../utils/interpolate-template';

export const BonusConditions = () => {
  const { translations } = useTranslations();
  const parts = translations?.bonus?.page_content?.how_to_get_bonus?.parts;

  if (!Array.isArray(parts) || parts.length === 0) return null;

  const [firstPart, ...restParts] = parts;
  const steps = firstPart?.list || [];

  return (
    <BonusConditionsCard>
      <BodyTextMediumA style={{fontWeight: 700}}>{firstPart?.template}</BodyTextMediumA>

      <StepsList>
        {steps.map((step, index) => (
          <li key={index}>
            <BodyTextRegularB color="#AFAFAF" >
              {interpolateTemplate(step, firstPart?.variables, WhiteText)}
            </BodyTextRegularB>
          </li>
        ))}
      </StepsList>

      {restParts.map((part, index) => (
        <BodyTextRegularB color="#AFAFAF" key={index}>
          {interpolateTemplate(part.template, part.variables, WhiteText)}
        </BodyTextRegularB>
      ))}
    </BonusConditionsCard>
  );
};
